import React from "react";
import { Link } from "react-router-dom";
import Ajax, { domain } from "../../ajax/Ajax";

class Signup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone: "",
      password: "",
      code: "",
      notifyPhoneEntry: false,
      notifyVerifySMS: false,
      sendingSMS: false,
      smsSent: false,
      errorSendingSMS: false,
      submitting: false,
      signupSuccess: false,
      signupError: false,
      invalidVerificationCode: false,
      userAlreadyExist: false,
    };

    this.sendSMS = this.sendSMS.bind(this);
    this.submitSignupForm = this.submitSignupForm.bind(this);
  }

  async sendSMS() {
    if (this.state.phone) {
      this.setState({
        sendingSMS: true,
        notifyPhoneEntry: false,
      });
    } else {
      this.setState({
        notifyPhoneEntry: true,
      });
      return;
    }

    let response = await Ajax.fetchData(
      domain +
        "/en/api/accounts/v1/phone-verification/?phone=" +
        this.state.phone
    );
    if (response) {
      if (response.status === 200) {
        this.setState({
          sendingSMS: false,
          smsSent: true,
        });
      } else {
        this.setState({
          sendingSMS: false,
          errorSendingSMS: true,
        });
      }
    } else {
      this.setState({
        sendingSMS: false,
        errorSendingSMS: true,
      });
    }
  }

  async submitSignupForm(event) {
    event.preventDefault();
    if (!this.state.smsSent) {
      this.setState({ notifyVerifySMS: true });
      return;
    }

    let data = {
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      password: this.state.password,
      code: this.state.code,
    };

    this.setState({
      submitting: true,
      userAlreadyExist: false,
      invalidVerificationCode: false,
      notifyVerifySMS: false,
    });

    let response = await Ajax.postData(
      domain + "/en/api/accounts/v1/signup/",
      data
    );
    console.log(response);
    if (response) {
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        this.setState({
          submitting: false,
          invalidVerificationCode: false,
          signupSuccess: true,
          name: "",
          email: "",
          phone: "",
          code: "",
          password: "",
        });

        setTimeout(function () {
          window.location.assign("/myshop/home/");
        }, 2000);
      } else if (response.status === 407) {
        this.setState({
          invalidVerificationCode: true,
          submitting: false,
        });
      } else if (response.status === 406) {
        this.setState({
          userAlreadyExist: true,
          submitting: false,
        });
      } else {
        this.setState({
          submitting: false,
        });
      }
    } else {
      this.setState({
        signupError: true,
        submitting: false,
      });
    }
  }

  componentDidMount() {
    if (localStorage.getItem("token")) {
      try {
        this.props.history.push("/myshop/home/");
      } catch (e) {
        window.location.assign("/myshop/home/");
      }
    }
  }

  render() {
    let sendingSMS = "";
    let submitting = "";

    if (this.state.sendingSMS) {
      sendingSMS = "is-loading";
    }

    if (this.state.submitting) {
      submitting = "is-loading";
    }

    return (
      <div className="animated fadeIn">
        <div className="signup d-flex align-items-center justify-content-center">
          <div className="">
            <div className="">
              <div className="">
                <div className="title has-text-centered">Create Account</div>
                <div className="card is-shadowless mt-4 signup-card">
                  <div className="card-content">
                    <div>
                      <form action="#" onSubmit={this.submitSignupForm}>
                        {this.state.signupSuccess ? (
                          <div className="message is-success">
                            <div className="message-body has-text-centered">
                              <span className="zmdi zmdi-check-circle mr-2"></span>
                              <p>Account Successfully Created!</p>
                              <p> Redirecting...</p>
                            </div>
                          </div>
                        ) : (
                          <span></span>
                        )}

                        {this.state.signupError ? (
                          <div className="message is-danger">
                            <div className="message-body">
                              <span className="zmdi zmdi-close-circle mr-2"></span>
                              An Error Occurred! Please try again later.
                            </div>
                          </div>
                        ) : (
                          <span></span>
                        )}

                        {this.state.invalidVerificationCode ? (
                          <div className="message is-danger">
                            <div className="message-body">
                              <span className="zmdi zmdi-close-circle mr-2"></span>
                              Invalid Verification Code.
                            </div>
                          </div>
                        ) : (
                          <span></span>
                        )}

                        {this.state.userAlreadyExist ? (
                          <div className="message is-danger">
                            <div className="message-body has-text-centered">
                              <span className="zmdi zmdi-check-circle mr-2"></span>
                              <p>User Already Exist!</p>
                              <p>Please Choose a Different Email.</p>
                            </div>
                          </div>
                        ) : (
                          <span></span>
                        )}

                        {!this.state.signupSuccess ? (
                          <div>
                            <div className="field">
                              <label className="label">Name</label>
                              <div className="control has-icons-left">
                                <input
                                  required
                                  placeholder="full name"
                                  onChange={(event) => {
                                    this.setState({ name: event.target.value });
                                  }}
                                  value={this.state.name}
                                  type="text"
                                  className="input"
                                />
                                <span className="icon is-left">
                                  <span className="zmdi zmdi-account"></span>
                                </span>
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">Email</label>
                              <div className="control has-icons-left">
                                <input
                                  required
                                  placeholder="email"
                                  onChange={(event) => {
                                    this.setState({
                                      email: event.target.value,
                                      userAlreadyExist: false,
                                    });
                                  }}
                                  value={this.state.email}
                                  type="email"
                                  className="input"
                                />
                                <span className="icon is-left">
                                  <span className="zmdi zmdi-email"></span>
                                </span>
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">Phone</label>
                              <div
                                className={
                                  "control has-icons-left " + sendingSMS
                                }
                              >
                                <input
                                  required
                                  placeholder="(+1) 895 45 6514"
                                  onChange={(event) => {
                                    this.setState({
                                      phone: event.target.value,
                                    });
                                  }}
                                  value={this.state.phone}
                                  type="text"
                                  className="input"
                                />
                                <span className="icon is-left">
                                  <span className="zmdi zmdi-phone"></span>
                                </span>
                              </div>
                              {this.state.smsSent ? (
                                <p className="d-flex justify-content-between">
                                  <span>
                                    {this.state.sendingSMS ? (
                                      <span className="has-text-info">
                                        Sending...
                                      </span>
                                    ) : (
                                      <span className="has-text-success">
                                        SMS Sent!
                                      </span>
                                    )}
                                  </span>
                                  <span
                                    onClick={this.sendSMS}
                                    className="has-text-info static-link"
                                  >
                                    Resend
                                  </span>
                                </p>
                              ) : (
                                <div className="d-flex justify-content-between animated fadeIn">
                                  {this.state.notifyVerifySMS ? (
                                    <p className="has-text-danger">
                                      <small>Please verify your phone</small>
                                    </p>
                                  ) : (
                                    <p>
                                      {this.state.notifyPhoneEntry ? (
                                        <span className="has-text-danger">
                                          <small>Enter a Phone Number</small>
                                        </span>
                                      ) : (
                                        <span></span>
                                      )}
                                    </p>
                                  )}

                                  <p
                                    onClick={this.sendSMS}
                                    className="has-text-info has-text-right static-link"
                                  >
                                    Verify
                                  </p>
                                </div>
                              )}
                            </div>

                            {this.state.smsSent ? (
                              <div className="field animated fadeIn">
                                <div className="control has-icons-left">
                                  <input
                                    required
                                    placeholder="verification code"
                                    onChange={(event) => {
                                      this.setState({
                                        code: event.target.value,
                                      });
                                    }}
                                    value={this.state.code}
                                    type="text"
                                    className="input"
                                  />
                                  <span className="icon is-left">
                                    <span className="zmdi zmdi-comment"></span>
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div></div>
                            )}

                            <div className="field">
                              <label className="label">Password</label>
                              <div className="control has-icons-left">
                                <input
                                  required
                                  placeholder="***********"
                                  onChange={(event) => {
                                    this.setState({
                                      password: event.target.value,
                                    });
                                  }}
                                  value={this.state.password}
                                  type="password"
                                  className="input"
                                />
                                <span className="icon is-left">
                                  <span className="zmdi zmdi-lock"></span>
                                </span>
                              </div>
                            </div>

                            <div className="field">
                              <button
                                disabled={this.state.submitting}
                                className={
                                  "button is-info is-fullwidth " + submitting
                                }
                              >
                                <span className="zmdi zmdi-account-add mr-2"></span>
                                <span>Create Account</span>
                              </button>
                            </div>

                            <div className="field">
                              <span>Already have an Account? </span>
                              <span>
                                <Link to="/login/">Login</Link>
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Signup;
